/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { LegalDocument } from '../models/LegalDocument';
import type { PaginatedLegalDocumentList } from '../models/PaginatedLegalDocumentList';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class LegalDocumentsService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Public, read-only access to legal documents (e.g. privacy policy, terms).
     * Retrieval is by ``key`` and returns the latest version.
     * @returns PaginatedLegalDocumentList
     * @throws ApiError
     */
    public legalDocumentsList({
        limit,
        offset,
    }: {
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
    }): CancelablePromise<PaginatedLegalDocumentList> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/legal-documents/',
            query: {
                'limit': limit,
                'offset': offset,
            },
        });
    }

    /**
     * Public, read-only access to legal documents (e.g. privacy policy, terms).
     * Retrieval is by ``key`` and returns the latest version.
     * @returns LegalDocument
     * @throws ApiError
     */
    public legalDocumentsRetrieve({
        key,
        audience,
    }: {
        key: 'terms' | 'privacy',
        /**
         * Prefer the versions for this audience, the ones its consent records.
         */
        audience?: 'Company Manager' | 'Employee',
    }): CancelablePromise<LegalDocument> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/legal-documents/{key}/',
            path: {
                'key': key,
            },
            query: {
                'audience': audience,
            },
        });
    }

}
